<template>
  <v-menu
    v-model="isOpen"
    bottom
    offset-y
    right
    :close-on-content-click="false"
    max-height="1000"
    max-width="1000"
    z-index="0"
  >
    <template v-slot:activator="{ on: menu, attrs }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            v-if="allDocumentsList.length"
            v-bind="attrs"
            v-on="{ ...tooltip, ...menu }"
            style="padding: 0 2px; margin-left: 5px"
            color="primary"
            dark
            height="16"
            min-width="16"
            text
            small
            @click.stop.prevent
          >
            <v-icon small>mdi-attachment</v-icon>({{
              allDocumentsList.length
            }})</v-btn
          >
        </template>
        <span>{{ allDocumentsList.length }} {{$t('agenda.lblDocumentAttached')}}</span>
      </v-tooltip>
    </template>
    <v-toolbar color="pageHeader" dark height="32px" flat tile>
      {{ title }}
    </v-toolbar>
    <v-card flat tile width="100%">
      <v-card-text class="pa-3">
        <v-row>
          <v-data-table
            v-model="selectedFiles"
            :headers="headers"
            :items="allDocumentsList"
            fixed-header
            dense
            flat
            color="appBar"
            :items-per-page="-1"
            hide-default-footer
            mobile-breakpoint="0"
            :no-data-text="$t('noData')"
            show-select
            item-key="documentId"
            height="300"
          >
            <template v-slot:[`item.fileName`]="{ item }">
              <v-icon v-if="!item.extension">{{
                getFileIcon(item.fileName)
              }}</v-icon>
              <v-icon v-else>
                {{ fileIcons[item.extension] || "mdi-file" }}
              </v-icon>
              <a @click="onFileDownload(item)">{{ item.fileName }}</a>
              <!-- <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <a v-bind="attrs" v-on="on" @click="onFileDownload(item)">{{
                    item.fileName
                  }}</a>
                </template>
                <p class="ma-0">File Name: {{ item.fileName }}</p>
                <p class="ma-0" v-if="item.size">
                  Size: {{ formatBytes(item.size) }}
                </p>
                <p class="ma-0" v-if="item.lastModified">
                  Uploaded Time:
                  {{ currentDateTime(item.lastModified) }}
                </p>
              </v-tooltip> -->
            </template>

            <template v-slot:[`item.size`]="{ item }">
              {{ item.size ? formatBytes(item.size) : "-" }}
            </template>
            <template v-slot:[`item.lastModified`]="{ item }">
              {{
                item.lastModified
                  ? convertIntlDateFormat(item.lastModified)
                  : "-"
              }}
            </template>
          </v-data-table>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="pageHeader" small text @click="isOpen = false">{{
          $t("btnClose")
        }}</v-btn>
        <v-btn
          :disabled="!selectedFiles.length"
          color="pageHeader"
          text
          small
          @click="onOpenAllDocuments()"
          >{{ $t("btnOpenAll") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { mapActions } from "vuex";
import { formatBytes, convertIntlDateFormat,openDocument } from "../../utils/util";
export default {
  name: "AgendaViewDocumentList",
  props: {
    documents: {
      type: Array,
      default: () => [],
    },
    momDocuments: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "",
    },
    hasTopic: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedFiles: [],
      isOpen: false,
      fileIcons: {
        zip: "mdi-folder-zip-outline",
        rar: "mdi-folder-zip-outline",
        htm: "mdi-language-html5",
        html: "mdi-language-html5",
        js: "mdi-nodejs",
        json: "mdi-json",
        md: "mdi-markdown",
        pdf: "mdi-file-pdf-box",
        png: "mdi-file-image",
        jpg: "mdi-file-image",
        jpeg: "mdi-file-image",
        mp4: "mdi-filmstrip",
        mkv: "mdi-filmstrip",
        avi: "mdi-filmstrip",
        wmv: "mdi-filmstrip",
        mov: "mdi-filmstrip",
        txt: "mdi-file-document-outline",
        xls: "mdi-file-excel",
        xlsx: "mdi-file-excel",
        ppt: "mdi-file-powerpoint",
        pptx: "mdi-file-powerpoint",
        other: "mdi-file-outline",
      },
    };
  },
  computed: {
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },

    selectedLang() {
      return this.$i18n.locale;
    },
    headers() {
      const fields = [
        {
          text: this.$t("documents.name"),
          align: "left",
          value: "fileName",
          width: 350,
          visible: true,
        },
        {
          text: this.$t("documents.topic"),
          align: "left",
          value: "topicName",
          width: 200,
          visible: this.hasTopic,
        },
        {
          text: this.$t("documents.size"),
          align: "left",
          value: "size",
          width: 100,
          visible: true,
        },
        {
          text: this.$t("search.modifiedDate"),
          align: "left",
          value: "lastModified",
          width: 230,
          visible: true,
        },
        // {
        //   text: this.$t("search.uploadedBy"),
        //   align: "left",
        //   value: "uploadedBy",
        //   width: 200,
        //   visible: true,
        // },
      ];
      return fields.filter((f) => f.visible === true);
    },
    momDocumentsList() {
      return this.momDocuments.map((obj) => {
        return { ...obj, topicName: this.$t("agenda.lblMOM") };
      });
    },
    allDocumentsList() {
      // return this.documents.concat(this.momDocumentsList);
      return this.documents;
    },
  },
  watch: {
    isOpen(value) {
      if (!value) {
        this.selectedFiles = [];
      }
    },
  },
  methods: {
    ...mapActions({
      downloadDocumentAPI: "document/downloadDocument",
    }),
    onFileDownload,
    onOpenAllDocuments,
    formatBytes,
    convertIntlDateFormat,
    getFileIcon,
  },
};

function getFileIcon(filename) {
  let strArr = filename.split(".");
  let arrlength = strArr.length;
  if (arrlength > 0) {
    return this.fileIcons[strArr[arrlength - 1].toLowerCase()] || "mdi-file";
  }

  return "mdi-file";
}

async function onFileDownload(file) {
  const params = {
    documentId: file.documentId,
    filename: file.fileName,
  };
  const res = await this.downloadDocumentAPI(params);
  var contentType = res.headers["content-type"];
  var blob = new Blob([res.data], { type: contentType });
  var url = window.URL.createObjectURL(blob);
  openDocument(url,file.fileName);
}

function onOpenAllDocuments() {
  this.selectedFiles.forEach(async (file) => {
    const params = {
      documentId: file.documentId,
      filename: file.fileName,
    };
    const res = await this.downloadDocumentAPI(params);
    var contentType = res.headers["content-type"];
    var blob = new Blob([res.data], { type: contentType });
    var url = window.URL.createObjectURL(blob);
    openDocument(url,file.fileName);    
  });
}
</script>

<style scoped>
.max-height {
  max-height: 30vh;
  /* overflow: auto; */
}

::v-deep .v-data-table__wrapper {
  max-height: 200px !important;
}

::v-deep th {
  background-color: var(--v-appBar-darken1) !important;
}
</style>

